import { Component, EventEmitter, Input, Output } from "@angular/core";
import { DeudaGraciaPendiente } from "src/app/models/PlanesUsuario/DeudaGraciaPendiente";

@Component({
	selector: "app-deuda-gracia-card",
	templateUrl: "./deuda-gracia-card.component.html",
	styleUrls: ["./deuda-gracia-card.component.scss"],
})
export class DeudaGraciaCardComponent {
	@Input() deuda: DeudaGraciaPendiente = new DeudaGraciaPendiente();
	@Input() pagando = false;
	@Input() mensaje = "Debes pagar esta regularización para poder contratar un nuevo periodo. Corresponde a medio mes del plan vigente al vencimiento.";
	@Output() pagar = new EventEmitter<void>();

	get tieneDeuda(): boolean {
		return (this.deuda?.tieneDeuda ?? false) && !this.deuda?.ventanaEnCurso;
	}

	onPagar(): void {
		if (this.pagando) return;
		this.pagar.emit();
	}
}
